import videojs from 'video.js';

export class BigPlayButton extends videojs.getComponent('BigPlayButton') {
  handleClick(event) {
    // We only want to let the original BigPlayButton do its work
    // when we're playing a video. Otherwise it'll call `player.play()`
    // and that'll cause the first source set on the player to start
    // automatically, without us having the chance to control when players swap
    if (this.player().isVideo) {
      return super.handleClick(event);
    }
  }
}
